import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignDeleteModal = ({
  isOpen,
  template,
  isSubmitting,
  onClose,
  onConfirm
}) => {
  if (!isOpen || !template) {
    return null
  }

  return (
    <ConfirmationDialog
      title="Delete template?"
      positiveMessage="Delete"
      negativeMessage="Cancel"
      onClose={onClose}
      onConfirm={onConfirm}
      isButtonDisabled={isSubmitting}
      hasDangerousAction
      maxWidth={440}
    >
      <p>
        Are you sure you want to delete <strong>{template.name}</strong>? This cannot be
        undone.
      </p>
      <p className={styles.createModalHint}>
        Campaign message text is not affected. Only this saved layout is removed.
      </p>
    </ConfirmationDialog>
  )
}

export default InviteEmailDesignDeleteModal
